import React, { useEffect, useState } from "react";
import "./Auth.css";
import { auth, googleProvider, db } from "../config/firebase";
import { isAccessRestricted, isAllowedEmail } from "../config/allowedUsers";
import { FaGoogle, FaTwitter } from "react-icons/fa";
import {
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
  onAuthStateChanged,
  TwitterAuthProvider,
} from "firebase/auth";
import { setDoc, doc } from "firebase/firestore";

function Auth(props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [accessError, setAccessError] = useState("");
  const [signInError, setSignInError] = useState("");

  const signIn = async () => {
    try {
      setAccessError("");
      setSignInError("");
      const result = await signInWithEmailAndPassword(auth, email, password);
      if (!isAllowedEmail(result.user?.email)) {
        await signOut(auth);
        setAccessError("Access is restricted to approved accounts.");
        return;
      }
      props.closeAuthModal();
    } catch (err) {
      console.error(err);
      setSignInError(err.message || "Sign-in failed.");
    }
  };

  const signInWithGoogle = async () => {
    try {
      setAccessError("");
      setSignInError("");
      const result = await signInWithPopup(auth, googleProvider);

      if (result.user) {
        const { uid, displayName, email, photoURL } = result.user;

        if (!isAllowedEmail(email)) {
          await signOut(auth);
          setAccessError("Access is restricted to approved accounts.");
          return;
        }

        const userDoc = doc(db, "users", uid);
        await setDoc(userDoc, {
          userInfo: {
            email: email,
            name: displayName,
            photoURL: photoURL,
          },
        });
        props.closeAuthModal();
      }
    } catch (err) {
      console.error(err);
      setSignInError(err.message || "Sign-in failed.");
    }
  };

  const signInWithTwitter = async () => {
    const provider = new TwitterAuthProvider();
    try {
      setAccessError("");
      setSignInError("");
      const result = await signInWithPopup(auth, provider);

      if (result.user) {
        const { uid, displayName, email, photoURL } = result.user;

        if (!isAllowedEmail(email)) {
          await signOut(auth);
          setAccessError("Access is restricted to approved accounts.");
          return;
        }

        const userDoc = doc(db, "users", uid);
        await setDoc(userDoc, {
          userInfo: {
            email: email,
            name: displayName,
            photoURL: photoURL,
          },
        });
        props.closeAuthModal();
      }
    } catch (err) {
      console.error(err);
      setSignInError(err.message || "Sign-in failed.");
    }
  };

  const logout = async () => {
    try {
      await signOut(auth);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, () => {
      // auth state is reflected in UI via parent
    });
    return () => {
      unsubscribe();
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div className="container">
      <h1>Sign In</h1>
      <input
        className="input-box"
        placeholder="Email..."
        onChange={(e) => setEmail(e.target.value)}
      />
      <input
        className="input-box-bottom"
        placeholder="Password..."
        type="password"
        onChange={(e) => setPassword(e.target.value)}
      />
      <div className="center-div">
        <div className="inline-div">
          <button className="auth-action-button" onClick={signIn}>
            Sign In
          </button>
        </div>
      </div>
      {signInError && (
        <p className="auth-restricted">{signInError}</p>
      )}
      {(isAccessRestricted || accessError) && (
        <p className="auth-restricted">
          {accessError || "Access is restricted to approved accounts."}
        </p>
      )}
      <button
        className="full-width-button auth-provider-button"
        onClick={signInWithGoogle}
      >
        <FaGoogle aria-hidden="true" />
        <span>Google</span>
      </button>
      <button
        className="full-width-button auth-provider-button"
        onClick={signInWithTwitter}
      >
        <FaTwitter aria-hidden="true" />
        <span>Twitter</span>
      </button>

      {auth.currentUser && (
        <button onClick={logout} className="logout-button">
          Log Out
        </button>
      )}
    </div>
  );
}

export default Auth;
